module.exports = __webpack_public_path__ + "our-services-bg.9250bdb03d84d5dc3594.svg";


//////////////////
// WEBPACK FOOTER
// C:/unnati/latestWebCode29march/src/assets/images/our-services-bg.svg
// module id = ../../../../../src/assets/images/our-services-bg.svg
// module chunks = main